import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';
import { PhraseRapport } from './phrase-rapport.class';
import { Question } from './question.class';
import { Photo } from './photo.class';
import { v4 as uuidv4 } from 'uuid';

export class QuestionRapport {
	@Required
	@Primary
	id: string;

	@Required
	phraseRapport: PhraseRapport;

	phraseOrigin: PhraseRapport;
	phraseOriginId?: string;

	@Required
	question: Question;

	manualPhotos?: Photo[];
	value: string;
	condition?: string;
	prefix?: string;
	suffix?: string;
	lineBreak?: boolean;

	sameQuestionRapportId?: string;

	options: string[];
	
	@Required
	sort: number;

	constructor() {	
		if (!this.id) this.id = uuidv4();
	}
}
